import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Collapse } from 'reactstrap';
import { ConfirmationButton } from './Button';
import { ChevronDown } from 'react-feather';
import { PoppinsSemiBold } from './Fonts';

const SecText = ({ children }) => (
	<PoppinsSemiBold sx="18px" color="#00852A">
		{children}
	</PoppinsSemiBold>
);

const CardCollapsable = ({ title, isCollapsable, children, button, midElement }) => {
	const [isOpen, setIsOpen] = useState(true);
	return isCollapsable ? (
		<Card>
			<CardHeader>
				<SecText>{title}</SecText>
				{midElement && (
					<ConfirmationButton
						color={'transparent'}
						style={{
							color:'#103EA0',
							fontFamily:'Poppins SemiBold'
						}}
						icon={midElement.icon}
						label={midElement.label}
						onClick={midElement.onClick}
					/>
				)}
				{button && (
					<ConfirmationButton
						icon={button.icon}
						label={button.label}
						onClick={button.onClick}
					/>
				)}
				<ChevronDown
					className="cursor-pointer"
					color="green"
					onClick={() => setIsOpen(!isOpen)}
				/>
			</CardHeader>
			<Collapse isOpen={isOpen}>
				<CardBody>{children}</CardBody>
			</Collapse>
		</Card>
	) : (
		<Card>
			<CardHeader>
				<SecText>{title}</SecText>
				{button && (
					<ConfirmationButton
						icon={button.icon}
						label={button.label}
						onClick={button.onClick}
					/>
				)}
			</CardHeader>
			<CardBody>{children}</CardBody>
		</Card>
	);
};

export default CardCollapsable;
